import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/orderCalculator', request)
}

async function put(id, request) {
    return await putMethod(`/api/orderCalculator/${id}`, request)
}

export {get, put}
